import { takeLatest, put, call } from 'redux-saga/effects';
import swal from 'sweetalert';

import { history } from '@commons';

import { deletePlantioManejo } from '../service';
import {
  DELETE_PLANTIO_MANEJO,
  DELETE_PLANTIO_MANEJO_PENDING,
  DELETE_PLANTIO_MANEJO_SUCCESS,
  DELETE_PLANTIO_MANEJO_FAILURE,
} from '../actionTypes';

import { AlertError } from '@components/common/AlertToast'
import { trackingEventCX, MODULE_ACTIONS_ENUM } from '@handler/tracking/customerX';

function* sagaDeletePlantioManejo(action) {
  yield put({ type: DELETE_PLANTIO_MANEJO_PENDING, id: action.id })

  trackingEventCX('action', MODULE_ACTIONS_ENUM.EXECUCAO_ATIVIDADE_EXCLUIR);

  try {
    const a = yield call(deletePlantioManejo, action.id);

    if (a.status !== 204) {
      throw new Error('API delete request failed');
    }
    yield put({ type: DELETE_PLANTIO_MANEJO_SUCCESS, id: action.id });

    swal({
      title: 'Excluído!',
      icon: 'success',
      buttons: {
        cancel: false,
        confirm: {
          text: 'OK',
          value: true,
          visible: true,
          className: 'btn-primary',
          closeModal: true
        }
      }
    }).then(() => {
      history.go(0)
    });

  } catch (error) {

    yield put({ type: DELETE_PLANTIO_MANEJO_FAILURE });

    AlertError('Falha ao excluir o registro! Tente novamente...');
  }
}

export default function* watchDeletePlantioManejo() {
  yield takeLatest(DELETE_PLANTIO_MANEJO, sagaDeletePlantioManejo)
}
